import styled from 'styled-components';
import { device } from 'styles/medias';

export const SideBySideLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;

  @media ${device.lg} {
    grid-template-columns: 1fr 1fr;
  }
`;
